import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchStatistiqueBiensLocation = (payload) => async (dispatch) => {
  dispatch(changeIsLoading(true));
  try {
    console.log("payloadfectchStatistiqueBiensLocation", payload);
    const data = {
      annee: !payload.date_debut ? payload : null,
      date_debut: payload.date_debut,
      date_fin: payload.date_fin,
    };
    const response = await instance.post("nbreTotalProprietesLocation", data);
    console.log("REPONSE nbreTotalProprietesLocation2545", response?.data.data);
    const statistiqueData = response?.data.data.map((item) => {
      return {
        month: item.mois,
        Enregistre: item.totalBiens,
        louer: item.totalBienslouer,
      };
    });
    const statistiqueRevenu = response?.data.data.map((item) => {
      return {
        month: item.mois,
        revenus: item.totalRevenue,
      };
    });
    console.log("RESPONSE REVENU", statistiqueRevenu);
    console.log("REPONSE nbreTotalProprietesLocation", statistiqueData);
    dispatch(
      fetchStatistiquesFulfilled({
        bien: statistiqueData,
        revenu: statistiqueRevenu,
      })
    );
  } catch (error) {
    console.log();
  }
  dispatch(changeIsLoading(false));
};

export const fectchStatistiqueBiensVente = (payload) => async (dispatch) => {
  console.log("fectchStatistiqueBiensVente", payload);
  dispatch(changeIsLoading(true));
  try {
    const response = await instance.post("nbreTotalProprietesVenteMaison", {
      annee: payload,
    });
    console.log("/nbreTotalProprietesVenteMaison", response);
    const statistiqueDataMaison = response?.data.data.map((item) => {
      return {
        month: item.mois,
        Enregistre: item.totalBiens,
        vendus: item.totalBiensvendu,
      };
    });
    const statistiqueDataRevenu = response?.data.data.map((item) => {
      return {
        month: item.mois,
        revenus: item.totalRevenue,
      };
    });
    console.log("statistiqueDataRevenu", statistiqueDataRevenu);
    dispatch(
      fetchStatistiquesVenteMaisonFulfilled({
        maison: statistiqueDataMaison,
        revenu: statistiqueDataRevenu,
      })
    );
  } catch (error) {
    console.log();
  }
  dispatch(changeIsLoading(false));
};

export const fectchStatistiqueTerrainVente = (payload) => async (dispatch) => {
  dispatch(changeIsLoading(true));
  console.log("fectchStatistiqueTerrainVente", payload);
  try {
    const response = await instance.post("nbreTotalProprietesVenteTerrain", {
      annee: payload,
    });
    console.log("/nbreTotalProprietesVenteTerrain", response);
    const statistiqueDataMaison = response?.data.data.map((item) => {
      return {
        month: item.mois,
        Enregistre: item.totalBiens,
        vendus: item.totalBiensvendu,
      };
    });
    console.log("statistiqueDataMaison254", statistiqueDataMaison);
    const statistiqueDataRevenu = response?.data.data.map((item) => {
      return {
        month: item.mois,
        revenus: item.totalRevenue,
      };
    });
    console.log("statistiqueDataRevenu", statistiqueDataRevenu);
    dispatch(
      fetchStatistiquesVenteTerrainFulfilled({
        terrain: statistiqueDataMaison,
        revenu: statistiqueDataRevenu,
      })
    );
  } catch (error) {
    console.log();
  }
  dispatch(changeIsLoading(false));
};

export const statistiqueReducer = createSlice({
  name: "Statistique",
  initialState: {
    statistique: [],
    revenus: [],
    maisonVenteStatistique: [],
    revenuMaisonVenteStatistique: [],
    terrainVenteStatistique: [],
    revenuTerrainVenteStatistique: [],
    isloading: false,
  },
  reducers: {
    fetchStatistiquesFulfilled: (state, action) => {
      return {
        ...state,
        statistique: action.payload.bien,
        revenus: action.payload.revenu,
      };
    },
    fetchStatistiquesVenteMaisonFulfilled: (state, action) => {
      return {
        ...state,
        maisonVenteStatistique: action.payload.maison,
        revenuMaisonVenteStatistique: action.payload.revenu,
      };
    },
    fetchStatistiquesVenteTerrainFulfilled: (state, action) => {
      return {
        ...state,
        terrainVenteStatistique: action.payload.terrain,
        revenuTerrainVenteStatistique: action.payload.revenu,
      };
    },
    changeIsLoading: (state, action) => {
      return { ...state, isloading: action.payload };
    },
  },
});

export const {
  fetchStatistiquesFulfilled,
  fetchStatistiquesVenteTerrainFulfilled,
  fetchStatistiquesVenteMaisonFulfilled,
  changeIsLoading,
} = statistiqueReducer.actions;
export default statistiqueReducer.reducer;
